import { Transition } from '@headlessui/react';
import { forwardRef, Fragment, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { ThumbnailIcon } from '~components/icons/ThumbnailIcon';
import { Asset } from '~modules/media-library/model/Asset';
import { Button } from '~modules/media-library/view/Button';

type ZoomModalPanelProps = {
  asset: Asset;
  onClose?: () => void;
};

export const ZoomModalPanel = forwardRef<HTMLDivElement, JSX.IntrinsicElements['div'] & ZoomModalPanelProps>(
  function ZoomModalPanel({ asset, onClose, className, ...TheirProps }, ref) {
    return (
      <div
        className={`ml--zoom-modal--panel bg-transparent min-w-0 max-w-full min-h-0 max-h-full flex relative ${
          className ? className : ''
        }`}
        {...TheirProps}
        ref={ref}
      >
        <Button
          variant="icon"
          className="absolute bottom-full left-full border-none bg-transparent text-white"
          onClick={onClose}
        >
          <CloseIcon />
        </Button>

        <div className="ml--zoom-modal--panel-body overflow-hidden text-left">
          <figure className="relative flex justify-center items-center overflow-hidden transition bg-black bg-opacity-10 p-0 m-0">
            {!!asset.previews.details ? (
              <Transition
                appear
                as={Fragment}
                enter="ease-out duration-700"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                show
              >
                <img
                  className="select-none max-w-full max-h-full inline-block p-0 m-0 "
                  src={asset.previews.zoom}
                  alt={asset.attributes.title}
                />
              </Transition>
            ) : (
              <div className="w-1/3">
                <ThumbnailIcon className="text-black opacity-30 mt-2" />
              </div>
            )}
          </figure>
        </div>
      </div>
    );
  },
);
